import { FaustHooks } from "@faustwp/core";

export class RockHallTVRewrite {
	/**
	 * @param {FaustHooks} hooks
	 */
	apply(hooks: FaustHooks) {
    const { addFilter } = hooks;
    addFilter(
			"resolvedUrl",
			"rockhall",
			(resolvedUrl) => {
				if (resolvedUrl.match(/^\/rrtv\/c\/[^\/]+(?:\/v\/[^\/]+)?/)) {
					// Preserve query params when rewriting
					const url = new URL(resolvedUrl, 'http://dummy');
					return '/rrtv/' + url.search;
				}
        return resolvedUrl;
			},
		);
	}
}
